import type { AggTradesPayload } from 'types/RecentTrades';

import { useRecentTradesStoreBase } from '../recentTrades/recentTrades.store';

/**
 * Updates recent trades based on incoming aggregated trades payload
 */
const getRecentTrades = (payload: AggTradesPayload, selectedProductSymbol: string) => {
  useRecentTradesStoreBase
    .getState()
    .actions.updateRecentTrades(payload, selectedProductSymbol);
};

/**
 * Resets recent trades and last trade to initial state
 */
const resetRecentTrades = () => {
  useRecentTradesStoreBase.getState().actions.resetTrades();
};

export { getRecentTrades, resetRecentTrades };
